import React, { useEffect, useRef } from 'react'
import { useState } from 'react'
import { getCookie, setCookie } from '../../utils/cookie-handler'
import CookieBanner, { COOKIE_COOKIES } from './cookie-banner'
import HiringBanner, { COOKIE_HIRING } from './hiring-banner'

/**
 * Will display the first banner that has an unset cookie.
 * All banners set a cookie when closed.
 * When all cookie banners are set, no banner is displayed.
 */
const BannerList = [
  {
    name: COOKIE_COOKIES,
    Component: CookieBanner,
    blacklist: [],
  },
  {
    name: COOKIE_HIRING,
    Component: HiringBanner,
    blacklist: ['/careers'],
  },
]

function checkIfBlacklisted(banner) {
  if (!banner.blacklist || banner.blacklist.length === 0) {
    return false
  }
  if (typeof window !== 'undefined') {
    return banner.blacklist.some(
      (pathname) => window.location.pathname.indexOf(pathname) !== -1
    )
  }
  return false
}

const Banners: React.FC<{
  fluffee_blacklist: string[]
  hiring_banner?: HiringBanner
}> = ({
  fluffee_blacklist,
  hiring_banner
}) => {
  const fluffeeRef = useRef<HTMLElement | null>(null)
  const [bannerIndex, setBannerIndex] = useState(-1)

  const nextBanner = () => {
    setBannerIndex((prevBannerIndex) => {
      let nextBannerIndex = -1

      for (let i = prevBannerIndex + 1; i < BannerList.length; i++) {
        const cookieKey = BannerList[i].name
        const cookieExists = getCookie(cookieKey) === '1'
        const isBlacklisted = checkIfBlacklisted(BannerList[i]);

        if (!cookieExists || isBlacklisted) {
          nextBannerIndex = i
          i = BannerList.length
        }
      }

      if (nextBannerIndex === -1 || nextBannerIndex > 0) {
        showFluffee()
      }

      return nextBannerIndex
    })
  }

  const closeCallback = () => {
    const cookieKey = BannerList[bannerIndex]
    if (cookieKey) {
      setCookie(cookieKey.name, 1, 100)
    }

    nextBanner()
  }

  const showFluffee = () => {
    if (fluffeeRef.current) {
      // Show fluffee if not on blacklist
      if (
        typeof window !== 'undefined' &&
        fluffee_blacklist.indexOf(window.location.pathname) === -1
      ) {
        fluffeeRef.current.classList.add('is-visible')
      } else {
        fluffeeRef.current.classList.remove('is-visible')
        fluffeeRef.current.classList.add('is-hidden')
      }
    }
  }

  useEffect(() => {
    fluffeeRef.current = document.getElementById(FLUFFEE_ID)
    nextBanner()
  }, [])

  return (
    <>
      {bannerIndex > -1 &&
        BannerList.map((Banner, index) => {
          return (
            <Banner.Component
              key={index}
              closeCallback={closeCallback}
              hiddenClass={index !== bannerIndex ? 'is-hidden' : ''}
              data={Banner.name === COOKIE_HIRING ? hiring_banner : undefined}
            />
          )
        })}
    </>
  )
}

export const FLUFFEE_ID = 'fluffee-button'

export default Banners
